import { useQuery } from '@tanstack/react-query';
import { createApiClient } from '../client';
import { useAuth } from '../../auth/useAuth';

export interface AudioPlaylistItemDto {
  paragraphId: string;
  sequenceOrder: number;
  audioUrl: string | null;
  durationMs: number | null;
  speakerLabel: string | null;
}

export interface ChapterAudioPlaylistDto {
  chapterId: string;
  chapterTitle: string;
  items: AudioPlaylistItemDto[];
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export function useChapterAudioPlaylist(
  chapterId: string | null | undefined,
  enabled = true,
) {
  const { getToken } = useAuth();
  return useQuery<ChapterAudioPlaylistDto>({
    enabled: !!chapterId && enabled,
    queryKey: ['chapter-audio-playlist', chapterId],
    queryFn: async () => {
      const client = createApiClient(getToken);
      const res = await client
        .get(`api/v2/chapters/${chapterId}/audio-playlist`)
        .json<ApiResponse<ChapterAudioPlaylistDto>>();
      return res.data;
    },
  });
}
